<template>
  <b-col sm="6" lg="4" class="mb-5">
    <div class="card card--hotel shadow text-center">
      <div>
        <img
          crossorigin="anonymous"
          class="card__image"
          :alt="hotel.image.altText"
          :src="hotelImg"
        />
      </div>
      <div class="card__body">
        <div class="row">
          <div class="col-9">
            <div class="hotel-name">
              <a :href="hotel.overviewPath" target="_blank" rel="noopener noreferrer">
                <h2 class="h2 card__title text-left">{{ hotel.name }}</h2>
              </a>
            </div>
          </div>
          <div class="col-3 text-right logo d-flex align-items-center justify-content-end" v-if="hotel.coBrand">
            <div class="coBrandImage">
                <img
                    :src="coBrandImages[hotel.coBrand].originalLogoImg.url"
                    :alt="coBrandImages[hotel.coBrand].originalLogoImg.altText"
                    v-if="coBrandImages[hotel.coBrand]"
                />
            </div>
          </div>
          <div class="col-3 text-right logo "  v-else >
            <div class="logo-brand brand" :class="hotel.brand"></div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-12 d-flex align-items-center">
            <i class="icon-pin xs"></i>
            <span class="color-gunmetal text-left">
              {{ hotelLocation }}
            </span>
          </div>
        </div>
        <b-row class="mb-3">
          <b-col>
            <div
              class="room-price text-right d-flex flex-column justify-content-center"
              v-if="hotel.points"
            >
              <small class="color-black text-lower mw-100">{{ translate('hdFrom') }}</small>
              <span class="text-18 font-medium points">{{ hotel.points | toPoints }}</span>
              <small class="color-black text-lower mw-100">{{ translate('hdPerNight') }}</small>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="5" class="d-flex align-items-center">
            <div
              class="hotel-reviews"
              v-if="tripAdvisorRating && tripAdvisorRating.rating.reviewCount > 0"
            >
              <img
                :src="ratingImage"
                alt="tripadisor rating"
                class="tripadvisor-rating"
                crossorigin="anonymous"
              />
              <div class="review-number">
                <span itemprop="ratingCount" class="ratingCount">
                  {{
                    translate(
                      'hdReviews',
                      tripAdvisorRating.rating.reviewCount,
                      tripAdvisorRating.rating.reviewCount
                    )
                  }}
                </span>
              </div>
            </div>
          </b-col>
          <b-col cols="7">
            <button
              class="btn btn-secondary text-uppercase font-medium cta-book"
              @click="onShowCalendar(hotel)"
            >
              {{ translate('hdBookNow') }}
            </button>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-col>
</template>

<script>
import { getRatingImageForNumber } from '@/infrastructure/Tripadvisor'
import { buildImageUrl } from '@/infrastructure/Utils'
import { mapState } from 'vuex'

export default {
  name: 'HotelCard',
  props: {
    hotel: Object,
    tripAdvisorRating: Object
  },
  computed: {
    ...mapState(['coBrandImages']),
    hotelImg: function () {
      return buildImageUrl(this.hotel.image, 'Card')
    },
    ratingImage: function () {
      return getRatingImageForNumber(this.tripAdvisorRating.rating.bubbleRating)
    },
    hotelLocation() {
      const { city, state, country } = this.hotel
      return [city, state, country].filter(Boolean).join(', ')
    }
  },
  methods: {
    onShowCalendar(hotel) {
      window.selectedHotel = {
        name: hotel.name,
        code: hotel.code
      }
      window.roomDisplayParams = {
        activeTab: 'rewards',
        paymentOption: 'rdOnlyPointsAndCashPoints'
      }

      global.searchBarVue.$emit('showSaverCalendar', {
        hotelCode: hotel.code
      })
    }
  }
}
</script>
<style scoped lang="scss">
  .coBrandImage{
    max-width: 70px;
    img {
      width: 100%;
    }
  }
</style>
